/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const INTERVAL = feature.getSettingValue('INTERVAL');
    const intervalStr = INTERVAL.toString().replace('.', '_');
    const NAME = `timer_${intervalStr}s_${feature.getID()}`;
    const tickLinks = project.getNodeLinks(feature, 'timer_tick');

    blocks.push({
        location: 'GLOBAL_DIMS',
        blockType: BlockType.CODE,
        template: `dim ${NAME}_timer as dword\r\n`,
    });
    blocks.push({
        location: 'GLOBAL_DIMS',
        blockType: BlockType.CODE,
        template: `dim ${NAME}_count as dword`,
    });

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `declare ${NAME}_timer as dword`,
    });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `\t${NAME}_timer = ${INTERVAL} * 1000 / sys.onsystimerperiod / 10`,
    });

    if (tickLinks.length > 0) {
        const link = tickLinks[0];
        blocks.push({
            location: 'on_sys_timer',
            blockType: BlockType.CODE,
            template: `
    ${NAME}_count = ${NAME}_count + 1
    if ${NAME}_count > ${NAME}_timer then
        '****${link.getSourceId()}****'
        ${NAME}_count = 0
    end if`,
        });
    }

    return blocks;
};
